"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pointcut = (function () {
    function Pointcut() {
        this._applications = new Set();
    }
    Pointcut.prototype.apply = function (fn, woveMetadata) {
        var _this = this;
        if (this._applications.has(fn)) {
            return;
        }
        else {
            this._applications.add(fn);
        }
        this.jointPoints.forEach(function (jp) {
            var matches = jp.match(fn);
            jp.wove({ fn: fn, matches: matches, woveMetadata: woveMetadata }, _this.advice);
        });
    };
    return Pointcut;
}());
exports.Pointcut = Pointcut;
